<template>
    <el-menu
      default-active="5-1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#ffffff"
      text-color="#333"
      active-text-color="#ffffff">
      <el-submenu  v-for="item in hasChildren" :key="item.label" :index="item.index">
        <template slot="title">
          <!-- <i class="el-icon-location"></i> -->
          <span>{{  item.label  }}</span>
        </template>
          <el-menu-item v-for="deItem in item.children" :index="deItem.index" :key="deItem.path" @click="handMenu(deItem)">{{  deItem.label  }}</el-menu-item>
      </el-submenu>

      <el-menu-item v-for="item in noChildren" :key="item.path" :index="item.index" @click="handMenu(item)">
        <i class="el-icon-setting"></i>
        <span slot="title">{{  item.label  }}</span>
      </el-menu-item>

    </el-menu>
</template>


<script>


  export default {
    data(){
      return{
        menuData:this.$store.state.menuData,
        realMenuData:JSON.parse(localStorage.getItem('menu'))
        // realMenuData:this.$store.state.menuData
      }
    },
    mounted(){
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handMenu(item){
        console.log(item,'item');
        this.$router.push({name:item.name})
      }
    },
    computed:{
      hasChildren(){
        // return this.menuData.filter(item => item.children)
        return this.realMenuData.filter(item => item.children)
      },
      noChildren(){
        // return this.menuData.filter(item => !item.children)
        return this.realMenuData.filter(item => !item.children)
      },
    }
  }
</script>

<style lang="scss" scoped>

.el-menu{
  width: 100%;
  .is-active{
    background-color: #409eff !important;
  }

  .el-submenu{

    ::v-deep .el-submenu__title{
      // padding:0px!important;
      display: flex;
      align-items: center;
    }

    ::v-deep .el-submenu__title:active{
      background: #1abc91 !important;
      color: #ffffff !important;
    }
  }
}
</style>